import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=b2253dbe&scoped=true&"
import script from "./BlackList.vue?vue&type=script&lang=js&"
export * from "./BlackList.vue?vue&type=script&lang=js&"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=b2253dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2253dbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2253dbe')) {
      api.createRecord('b2253dbe', component.options)
    } else {
      api.reload('b2253dbe', component.options)
    }
    module.hot.accept("./BlackList.vue?vue&type=template&id=b2253dbe&scoped=true&", function () {
      api.rerender('b2253dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ActivityData/BlackList.vue"
export default component.exports